import { Button } from '@/components/ui/button';
import { PlusIcon } from '../../icons';

interface OrderSourcesToolbarProps {
  className?: string;
  onCreateNew?: () => void;
  // RBAC: New is a write action — hidden entirely for read-only users.
  canWrite?: boolean;
}

export function OrderSourcesToolbar({
  className,
  onCreateNew,
  canWrite = false,
}: OrderSourcesToolbarProps) {
  if (!canWrite) return null;

  return (
    <div className={className}>
      <div className="flex items-center gap-3">
        <Button onClick={onCreateNew ?? (() => {})}>
          <PlusIcon className="size-5" aria-hidden="true" />
          New order source
        </Button>
      </div>
    </div>
  );
}
